import React from 'react';

import { useTheme } from 'styled-components';

import {
    Wrapper,
    Heading,
    Container,
    HorizontalProgressBar,
    IconWrapper,
    Icon,
    StyledLink,
    LinkWrapper,
    InteractionWrapper
} from './Icons.styled';

import Grid, { Col } from 'Components/Grid';
import { LinkProps } from 'Elements/Link';

export interface SectionNavLinks {
    link: LinkProps;
    icon: React.ElementType;
}

export interface Props {
    heading?: string;
    headingType?: 'h2' | 'h3';
    progress?: number;
    links: SectionNavLinks[];
}

const Icons: React.FC<Props> = ({ links, progress = 1, heading, headingType = 'h2' }) => {
    const { colors } = useTheme();

    return (
        <Wrapper>
            <Grid>
                <Col>
                    {heading && <Heading as={headingType}>{heading}</Heading>}
                    <Container>
                        <HorizontalProgressBar $numberOfItems={links.length} $progress={progress} />
                        {links.map((item, index) => (
                            <LinkWrapper
                                $numberOfItems={links.length}
                                key={`${item.link.label}_${index}`}
                            >
                                <InteractionWrapper $border={progress - 1 >= index ? false : true}>
                                    <IconWrapper
                                        $backgroundColor={
                                            progress - 1 < index
                                                ? colors.primaryContrast.hex
                                                : progress - 1 === index
                                                ? colors.accents[5].hex
                                                : colors.accents[26].hex
                                        }
                                        $border={progress - 1 >= index ? false : true}
                                    >
                                        <Icon
                                            as={item.icon}
                                            $color={
                                                progress - 1 >= index
                                                    ? colors.primaryContrast.hex
                                                    : colors.accents[5].hex
                                            }
                                        />
                                    </IconWrapper>
                                    <StyledLink {...item.link}>{item.link.label}</StyledLink>
                                </InteractionWrapper>
                            </LinkWrapper>
                        ))}
                    </Container>
                </Col>
            </Grid>
        </Wrapper>
    );
};

export default Icons;
